<template lang="html">
	<div id="page__service-reports" class="center-panel">
		<md-content md-theme="white" v-loader-overlay="progress" class="md-elevation-1">
			<sort-table
				v-bind:columns="tableColumns" v-model="reports" v-on:refresh="getReports" v-bind:per-page="perPage" 
				v-bind:total="reportsAmount" table-id="report-services" default-order="desc" default-sort="id"
				v-bind:showAddButton="false" v-bind:noBreackColumns="['traking_number', 'id']" v-bind:refreshOnCreate="false"
			>
				<template slot="buttons">
					<z-button v-if="canPrintReport" v-on:click="printReport"> Распечатать </z-button>
				</template>

				<template slot="created_at" slot-scope="scope"> {{ scope.item.created_at ? moment(scope.item.created_at).format('DD.MM.YYYY') : 'Не установленна' }} </template>

				<template slot="weight" slot-scope="scope">
					<span v-if="scope.item.weight"> {{scope.item.weight}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="size" slot-scope="scope">
					<span v-if="scope.item.size"> {{scope.item.size}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="from" slot-scope="scope">
					<div v-if="scope.item.from" class="no-break-hidden"> <span> {{scope.item.from.value}} </span> </div>
					<span v-else> Не указан </span>
				</template>

				<template slot="to" slot-scope="scope">
					<div v-if="scope.item.to" class="no-break-hidden"> <span> {{scope.item.to.value}} </span> </div>
					<span v-else> Не указан </span>
				</template>

				<template slot="payer" slot-scope="scope">
					<div v-if="scope.item.payer" class="no-break-hidden"> <span> {{scope.item.payer.name}} </span> </div>
					<span v-else> Не указан </span>
				</template>

				<template slot="payment_method" slot-scope="scope">
					<span v-if="scope.item.payment_method"> {{scope.item.payment_method.name}} </span>
					<span v-else> Не указан </span>
				</template>

				<template slot="nds" slot-scope="scope">
					<span> {{ scope.item.nds }} </span>
				</template>

				<template slot="status" slot-scope="scope">
					<span v-if="scope.item.status" v-bind:style="'color: ' + scope.item.status.color + ';'"> {{scope.item.status.name}} </span>
					<span v-else> Не указан </span>
				</template>
			</sort-table>
		</md-content>
	</div>
</template>
<script>
	import SortTable from "@/components/SortTable"
	import reportsMenu from './reports-menu';
	import ZButton from '@/components/ZButton.vue';
	export default {
		components: { SortTable, reportsMenu, ZButton },
		data() {
			return {
				tableColumns: [
					{ label: 'Треккод',     field: 'traking_number',  sortable: true},

					{ label: 'Дата',     field: 'created_at',  sortable: true},
					
					{ label: 'Мест', field: 'seats_number',  sortable: true},
					{ label: 'Вес (кг)',    field: 'weight',  sortable: true},
					{ label: 'Объём (м<sup>3</sup>)', field: 'size',  sortable: true},
					
					{ label: 'Отправление', field: 'from'},
					{ label: 'Назначение', field: 'to'},

					{ label: 'Плательщик', field: 'payer'},
					{ label: 'НДС', field: 'nds'},

					{ label: 'Сумма услуг (руб.)', field: 'price_services'},
					{ label: 'Способ оплаты', field: 'payment_method'},

					{ label: 'Статус', field: 'status', sortable: true},
					{ label: '', field: 'actions'}
				],
				RLStatuses: [
					{id: 1, label: 'Создан'},
					{id: 2, label: 'В работе'},
					{id: 3, label: 'Машина принята'},
					{id: 4, label: 'Выдан на перемещение'},
					{id: 5, label: 'Выполнен'}
				],
				currentPage: 1,
				perPage: 50,
			}
		},
		created() {
			this.$store.commit('setTitle', 'Отчет по экспедированию');
		},
		computed: {
			/**
			 * Флаг загрузки текущего компонента
			 */
			progress() {
				return this.progressObj['get-services-reports'];
			},
			/**
			 * Объект флагов загрузки
			 */
			progressObj() {
				return this.$store.state.progressObj;
			},
			/**
			 * Список отчетов
			 */
			reports() {
				return this.$store.state.reports.services_report;
			},
			/**
			 * Количество отчетов
			 */
			reportsAmount() {
				return this.$store.state.reports.services_report_amount;
			},
			canPrintReport() {
				if (!this.$route.query || !this.$route.query.custom_filter) return;
				let filter = JSON.parse(this.$route.query.custom_filter);
				return Object.values(filter).find(item => !!item);
			}
		},
		methods: {
			/**
			 * Получение отчетов
			 */
			getReports(page, count, orderBy, orderType) {
				this.$store.commit('showProgressBar', 'get-services-reports');

				let filter = (this.$route.query && this.$route.query.custom_filter) ? JSON.parse(this.$route.query.custom_filter) : {};
				if (filter.date_from) filter.date_from = this.moment(filter.date_from).tz(this.$root.userTimezone).format('YYYY-MM-DD');
				if (filter.date_to)   filter.date_to   = this.moment(filter.date_to).tz(this.$root.userTimezone).format('YYYY-MM-DD');
				if (filter.city_from_ids) filter.city_from_ids = filter.city_from_ids.map(item => item.value);
				if (filter.city_to_ids)   filter.city_to_ids   = filter.city_to_ids.map(item => item.value);
				if (filter.city_ids)      filter.city_ids      = filter.city_ids.map(item => item.value);
				if (filter.service_ids)   filter.service_ids   = filter.service_ids.map(item => item.value);

				let data = {
					page:       (page)      ? page      : 1, 
					order_by:   (orderBy)   ? orderBy   : 'id', 
					order_type: (orderType) ? orderType : 'desc',
					count:      (count)     ? count     : 50,
					custom_filter: filter
				};
				this.$store.dispatch('reports/getServicesReport', data)
					.finally(() => this.$store.commit('hideProgressBar', 'get-services-reports'));
			},
			/**
			 * Печать отчета
			 */
			printReport() {
				this.printUserReport('services-report');
			},
			/**
			 * Метод для печати отчета
			 */
			printUserReport(type = null) {
				if (!type || !this.$route.query || !this.$route.query.custom_filter) return;
				let filter = JSON.parse(this.$route.query.custom_filter);
				if (filter.city_from_ids) filter.city_from_ids = filter.city_from_ids.map(item => item.value);
				if (filter.city_to_ids)   filter.city_to_ids   = filter.city_to_ids.map(item => item.value);
				if (filter.city_ids)      filter.city_ids      = filter.city_ids.map(item => item.value);
				if (filter.service_ids)   filter.service_ids   = filter.service_ids.map(item => item.value);

				if (!filter) return;

				let query = [('custom_filter=' + JSON.stringify(filter))];
				if (this.$route.query.orderBy)   query.push('order_by='   + this.$route.query.orderBy);
				if (this.$route.query.orderType) query.push('order_type=' + this.$route.query.orderType);
				
				let url = this.$store.state.endpoint + '/report/excel/' + type + '?' + query.join('&');
				window.open(url, '_blank').focus();
			}
		}
	}
</script>


// WEBPACK FOOTER //
// ServicesReport.vue?80d746e2